import React from 'react';
import Form from 'react-bootstrap/Form';

const ReusableSwitch = ({
  id,
  label,
  checked = false,
  disabled = false,
  onChange,
  ...rest
}) => {
  return (
    <div className='d-flex align-items-center justify-content-center flex-column'>
    <Form.Check
      type="switch"
      className='toll-switch'
      id={id}
      label={""}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      {...rest}
    />
    <Form.Label className="mt-1 label-below-switch" htmlFor="toll-switch">
      {label}
    </Form.Label>
    </div>
  );
};

export default ReusableSwitch;
